import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_ACCOUNT,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'
import { normalizeConnections } from '@/common/normalize'

/**
 * SNS 계정 연결 정보 호출
 * - api명세서: https://contentwavve.atlassian.net/wiki/spaces/PDD/pages/1604882048/account-gate+GET+v1+connections+-+SNS
 * @param {object} { token: string } credential
 * @returns {Promise<{data: {wavveId: string, snsList: any[]}} | undefined>}
 */
export const getConnections = async ({ token }) => {
  // sns 계정 연동화면 내 token은 url에서 추출하여 사용하므로 token을 인자로 넘겨받는다. (cookie 내 credential을 사용하지 않음)
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_ACCOUNT}/v1/connections`,
      method: HTTP_METHOD_GET,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return normalizeConnections(response)
  } catch (error) {
    return { error: error.response }
  }
}
